import { Component, OnInit } from '@angular/core';
import { switchMap } from 'rxjs';
import { AuthData } from 'src/app/api/contracts/auth';
import { AuthService } from 'src/app/auth/auth.service';
import { StorageKeys, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-debug',
  templateUrl: './debug.component.html',
  styleUrls: ['./debug.component.scss'],
})
export class DebugComponent implements OnInit {
  public isMinimized: boolean = true;

  constructor(
    private readonly authService: AuthService,
    private readonly storageService: StorageService
  ) {}

  ngOnInit() {
    return;
  }

  onToggle(): void {
    this.isMinimized = !this.isMinimized;
  }

  onCreateAuthData(): void {
    this.storageService
      .set<AuthData>(StorageKeys.AUTH_DATA, {
        token: '23423',
        refreshToken: '234234',
        refreshTokenExpiration: 1723602530,
      })
      .subscribe();
  }

  onLogout(): void {
    this.authService.logout().subscribe();
  }

  onExpireToken(): void {
    this.authService
      .getStoredAuthData()
      .pipe(
        switchMap((authData) => {
          return this.storageService.set<AuthData>(StorageKeys.AUTH_DATA, {
            token: 'zxc',
            refreshToken: authData!.refreshToken,
            refreshTokenExpiration: 123,
          });
        })
      )
      .subscribe();
  }
}
